import React, { FC } from "react";
import { Formik, FormikHelpers } from "formik";
import { useWizard } from "./context";
import { Col, Row } from "taltech-styleguide";
import { SubmitBtn } from "../ProgressButtons";
import { isLastStep } from "./predicates";
import { useNotifications } from "@hooks";

interface ProgressWizardStepFormProps {
  title: string;
  element: any;
  schema: any;
  children: any;
}

export const ProgressWizardStepForm: FC<ProgressWizardStepFormProps> = ({
  title,
  element,
  children,
  schema,
  ...rest
}) => {
  const wizard = useWizard();
  const userNotificaions = useNotifications();

  return (
    <>
      <Formik
        initialValues={element}
        validationSchema={schema}
        innerRef={(instance) =>
          (wizard.state.refs.current[wizard.state.stepIndex] = instance!)
        }
        onSubmit={(values, helpers: FormikHelpers<any>) => {
          return helpers
            .validateForm()
            .then(() => {
              wizard.dispatch({ type: "SUBMIT_FORM_STEP", payload: values });
            })
            .catch((error) => {
              userNotificaions.error({ title: error });
              return Promise.reject(error);
            });
        }}
      >
        {(formik) => children}
      </Formik>
      <Row>
        {isLastStep(wizard.state) && (
          <Col sm="12" md="2">
            <SubmitBtn
              {...wizard.state.submitBtn}
              onClick={(evt: any) => {
                (wizard as any).state.submitBtn.onClick(wizard.state);
              }}
            />
          </Col>
        )}
      </Row>
    </>
  );
};
